'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callApiFactory = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _config = require('../config');

var callApiFactory = function callApiFactory(version) {
  return function (method, endpoint, payload, contentType, customHeaders) {
    var url = '' + (0, _config.getApiUrl)(version) + endpoint;
    var headers = _extends({
      'token': (0, _config.getAuthToken)() || ''
    }, (0, _config.getHeaders)(), customHeaders || {});
    var fetchOptions = {
      headers: headers,
      method: method
    };

    if (contentType) {
      headers["Content-Type"] = contentType;
    }

    if (payload) {
      switch (contentType) {
        case 'application/json':
          fetchOptions['body'] = payload ? JSON.stringify(payload) : null;
          break;
        default:
          fetchOptions['body'] = payload;
          break;
      }
    }

    return fetch(url, fetchOptions).then(function (response) {
      if (response.status == 504) {
        var error = new Error('Your request timed out. It may be too large.');
        error.status = response.status;
        return Promise.reject(error);
      }
      return response;
    }).then(function (response) {
      if (response.status == 204) {
        return null;
      }
      return response.json().then(function (json) {
        return { json: json, response: response };
      }).catch(function (error) {
        return { message: 'Invalid Data', parseError: true, response: response };
      });
    }).then(function (result) {
      if (!result) {
        return Promise.resolve({});
      }
      var response = result.response,
          json = result.json,
          parseError = result.parseError,
          message = result.message;


      if (!response.ok) {
        var error = new Error(json && json.message || message);
        error.status = response.status;
        return Promise.reject(error);
      }

      if (parseError) {
        var _error = new Error(message);
        return Promise.reject(_error);
      }

      return Promise.resolve(json);
    });
  };
};

exports.default = callApiFactory();
exports.callApiFactory = callApiFactory;


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/callApi.js
// module id = 31
// module chunks = 0